import { ActionBase } from '../../../core/store/action/ActionBase';
import { DateFramedMessageModel } from '../../models/DateFramedMessageModel';

export const EXPIRE_NOTIFICATION_SUCCESS_ACTION = '[Configuration] Messages Expire Notification Success Action';

export class ExpireNotificationSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = EXPIRE_NOTIFICATION_SUCCESS_ACTION;

  constructor(public payload: { expiredNotification: DateFramedMessageModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/ExpireNotificationSuccessAction.ts